import React, { useEffect,useState } from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import Swal from "sweetalert2";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowUp, faCartShopping, faCreditCard, faHeadphonesSimple, faSackDollar, faShieldHeart, faTruck } from "@fortawesome/free-solid-svg-icons";
import {
  faGoogle,
  faFacebook,
  faTwitter,
  faInstagram,
  faLinkedin,
  faPinterest,
} from "@fortawesome/free-brands-svg-icons";

import logo from "../../assets/img/logo.png";
import payment from "../../assets/img/common/payment.png";
import useAuth from "../../hooks/useAuth";
import "./Footer.css"
//-----------------------------------------------------------------

const FooterData = [
  {
    title: "INFORMATION",
    links: [
      { linkTitle: "Home", link: "/" },
      { linkTitle: "About us", link: "/about-us" },
      { linkTitle: "Privacy Policy", link: "/privacy-policy" },
      { linkTitle: "Frequently Questions", link: "/faqs" },
      // { linkTitle: "Order Tracking", link: "/order-tracking" },
      // { linkTitle: "Compare", link: "/compare" },
    ],
  },
  
];

const FooterData2 =
[
  {
    title: "SHOP",
    links: [
      { linkTitle: "Cart", link: "/cart" },
      { linkTitle: "Wishlist", link: "/user/wishlist" },
    ],
  },

]


const MainFooter = () => {

  // const {isAuthenticated, user} = useAuth()

  // let dispatch = useDispatch();

  // // let promoCenter = useSelector((state) => state.settings.promoCenter);
  // let promoStatus = useSelector((state) => state.settings.promoStatus);
  // // let stopPromo = useSelector((state) => state.settings.stopPromo);
  // // let cookie = useSelector((state) => state.settings.cookie);
  // let stopCookie = useSelector((state) => state.settings.stopCookie);

  // const [visible, setVisible] = useState(false);

  // const toggleVisible = () => {
  //   const scrolled = document.documentElement.scrollTop;
  //   if (scrolled > 100) {
  //     setVisible(true);
  //   } else if (scrolled <= 100) {
  //     setVisible(false);
  //   }
  // };

  // const scrollToTop = () => {
  //   window.scrollTo({
  //     top: 0,
  //     behavior: "smooth",
  //   });
  // };

  // window.addEventListener("scroll", toggleVisible);

  // useEffect(() => {
  //   if (promoStatus) {
  //     return;
  //   } else {
  //     dispatch({ type: "settings/promoStatus" });
  //     setTimeout(function () {
  //       dispatch({ type: "settings/promoCenter" });
  //     }, 2000);
  //   }

  //   if (stopCookie) {
  //     return;
  //   } else {
  //     setTimeout(function () {
  //       dispatch({ type: "settings/cookie" });
  //     }, 6000);
  //   }

  //   return () => {console.log()}
  // }, [dispatch, promoStatus, stopCookie]);

  // const startPromoModal = () => {
  //   if (stopPromo) {
  //     dispatch({ type: "settings/promoCenter" });
  //     return;
  //   } else {
  //     dispatch({ type: "settings/promoCenter" });
  //     setTimeout(function () {
  //       dispatch({ type: "settings/promoCenter" });
  //     }, 700000);
  //   }
  // };

  // const stopPromoModal = () => {
  //   dispatch({ type: "settings/stopPromo" });
  // };

  // const cancelCookie = () => {
  //   dispatch({ type: "settings/cookie" });
  // };

  // const acceptCookie = () => {
  //   // Write your function there
  //   dispatch({ type: "settings/cookie" });
  // };

  // 
  return (
    <>
      <footer id="footer" className="footer_wrapper pt-4">
    <div className="container">
        <div className="row">
            <div className="col-lg-3 col-md-6 col-6 border-end border-md-0">
                <div className="ecom_feature text-center mb-lg-0 mb-md-4 mb-4">
                  <FontAwesomeIcon icon={faSackDollar} size="2x"/>
                    <h4 className="bodytext h5">Great value</h4>
                    <p className="small text-muted lh-base mt-2">We offer competitive prices on over 100 million items.</p>
                </div>
            </div>
             {/* <div className="col-lg-2 col-md-6 col-6 border-end border-md-0">
                <div className="ecom_feature text-center mb-lg-0 mb-md-4 mb-4">
                  <FontAwesomeIcon icon={faTruck} size="2x"/>
                    <h4 className="bodytext h5">Worldwide shopping</h4>
                    <p className="small text-muted lh-base mt-2">We offer competitive prices on over 100 million items.</p>
                </div>
            </div>  */}
            <div className="col-lg-3 col-md-6 col-6 border-end border-md-0">
                <div className="ecom_feature text-center mb-lg-0 mb-md-4 mb-4">
                  <FontAwesomeIcon icon={faCreditCard} size="2x"/>

                    <h4 className="bodytext h5">Safe payment</h4>
                    <p className="small text-muted lh-base mt-2">We offer competitive prices on over 100 million items.</p>
                </div>
            </div>
             {/* <div className="col-lg-2 col-md-6 col-6 border-end border-md-0">
                <div className="ecom_feature text-center mb-lg-0 mb-md-4 mb-4">
                  <FontAwesomeIcon icon={faShieldHeart} size="2x"/>

                    <h4 className="bodytext h5">Shop with confidence</h4>
                    <p className="small text-muted lh-base mt-2">We offer competitive prices on over 100 million items.</p>
                </div>
            </div>  */}
            <div className="col-lg-3 col-md-6 col-6 border-end border-md-0">
                <div className="ecom_feature text-center mb-lg-0 mb-md-4 mb-4">
                  <FontAwesomeIcon icon={faHeadphonesSimple} size="2x"/>
                    <h4 className="bodytext h5">Help center</h4>
                    <p className="small text-muted lh-base mt-2">We offer competitive prices on over 100 million items.</p>
                </div>
            </div>
            <div className="col-lg-3 col-md-6 col-6">
                <div className="ecom_feature text-center mb-lg-0 mb-md-4 mb-4">
                    {/* <i className="fa-solid fa-cart-shopping"></i> */}
                  <FontAwesomeIcon icon={faCartShopping} size="2x"/>

                    <h4 className="bodytext h5">Shop better</h4>
                    <p className="small text-muted lh-base mt-2">We offer competitive prices on over 100 million items.</p>
                </div>
            </div>
        </div>
        <div className="row mt-4 py-4 border-top border-bottom">
            <div className="col-sm-6 col-xl-3">
                <div className="footer-widget mb-xl-0 mb-md-3 mb-3">
                    <h3 className="footer-title text-capitalize mb-3">Discover Products</h3>
                    <div className="footer-links">
                        <ul>
                            <li><a href="#" className="text-muted">Vehicle Parts & Accessories</a></li>
                            <li><a href="#" className="text-muted">Consumer Electronics</a></li>
                            <li><a href="#" className="text-muted">Home Appliances</a></li>
                            <li><a href="#" className="text-muted">Fashion Accessories</a></li>
                            <li><a href="#" className="text-muted">Furniture</a></li>
                        </ul>
                    </div>
                </div>
            </div>
            <div className="col-sm-6 col-xl-3">
                <div className="footer-widget mb-xl-0 mb-md-3 mb-3">
                    <h3 className="footer-title text-capitalize mb-3">Customer Services</h3>
                    <div className="footer-links">
                        <ul>
                            <li><a href="#" className="text-muted">About Us</a></li>
                            <li><a href="#" className="text-muted">Sitemap</a></li>
                            <li><a href="#" className="text-muted">Report Abuse</a></li>
                            <li><a href="#" className="text-muted">Submit a Dispute</a></li>
                            <li><a href="#" className="text-muted">Rules and Terms</a></li>
                        </ul>
                    </div>
                </div>
            </div>
            <div className="col-sm-6 col-xl-3">
                <div className="footer-widget mb-xl-0 mb-md-3 mb-3">
                    <h3 className="footer-title text-capitalize mb-3">Help</h3>
                    <div className="footer-links">
                        <ul>
                            <li><a href="#" className="text-muted">FAQ</a></li>
                            <li><a href="#" className="text-muted">Contact Us</a></li>
                            <li><a href="#" className="text-muted">Money Refund</a></li>
                            <li><a href="#" className="text-muted">Fashion Accessories</a></li>
                            <li><a href="#" className="text-muted">Submit a Complaint</a></li>
                        </ul>
                    </div>
                </div>
            </div>
            <div className="col-sm-6 col-xl-3">
                <div className="footer-widget mb-xl-0 mb-md-3 mb-3">
                    <h3 className="footer-title text-capitalize mb-3">Resources</h3>
                    <div className="footer-links">
                        <ul>
                            <li><a href="#" className="text-muted">Partnerships</a></li>
                            <li><a href="#" className="text-muted">Request for Quotation</a></li>
                            <li><a href="#" className="text-muted">Ready to Ship</a></li>
                            <li><a href="#" className="text-muted">Buyer Partners</a></li>
                            <li><a href="#" className="text-muted">Affiliate program</a></li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <div className="row py-3 border-bottom">
            <div className="col-lg-4 col-md-6">
                <div className="footer-app d-flex align-items-center mb-lg-0 mb-md-3 mb-3">
                    <span className="me-2">Download: </span>
                    <a href="#" className="me-2"><img src={require('../../assets/img/footer/google-store.png')} width="92" alt="google"/></a>
                    <a href="#"><img src={require('../../assets/img/footer/app-store.png')} width="92" alt="app"/></a>
                </div>
            </div>
            <div className="col-lg-4 col-md-6">
                <div className="footer-pay d-flex align-items-center justify-content-lg-center justify-content-md-end mb-lg-0 mb-md-3 mb-3">
                    <img src={require('../../assets/img/footer/paypal.jpg')} id="paypal" alt="payment"/>
                    <img src={require('../../assets/img/footer/maestro.jpg')} id="maestro" alt="payment"/>
                    <img src={require('../../assets/img/footer/discover.jpg')} id="discover" alt="payment"/>
                    <img src={require('../../assets/img/footer/visa.jpg')} id="visa" alt="payment"/>
                </div>
            </div>
            <div className="col-lg-4 col-md-6">
                <div className="footer-social d-flex align-items-center justify-content-lg-end">
                    <span className="me-2">Follow Us: </span>
                    <Link  to={'/facebook.com'}>
                      <FontAwesomeIcon  icon={faFacebook}/>
                    </Link>
                    <Link to={'/twitter.com'}>
                      <FontAwesomeIcon   icon={faTwitter}/>
                    </Link>
                    <Link to={'/linkedin.com'}>
                      <FontAwesomeIcon   icon={faLinkedin}/>
                    </Link>
                    <Link to={'/pinterest.com'}>
                      <FontAwesomeIcon   icon={faPinterest}/>
                    </Link>
                    <Link  to={'/instagram.com'}>
                      <FontAwesomeIcon  icon={faInstagram}/>
                    </Link>
                </div>
            </div>
        </div>
        <div className="row text-center py-3">
            <div className="col-lg-12">
                <p className="text-muted small"><span className="pe-2">Copyright {`${new Date().getFullYear()}`} {process.env.REACT_APP_NAME}. All Rights Reserved.</span><a href="#" className="text-muted border-end border-start px-2">User Agreement</a><a href="#" className="text-muted px-2">Terms of Use</a> <a href="#" className="text-muted border-start ps-2">Privacy Policy</a></p>
            </div>
        </div>
    </div>
</footer>
    </>
  );
};

export default MainFooter;
